















































import {Component, Prop, Vue} from 'vue-property-decorator';
import ApiClient from "@/common/ApiClient";
import FirebaseConnectionStore from "@/store/modules/FirebaseConnection/FirebaseConnectionStore";
import moment from 'moment'
import Utils from "@/common/Utils";


@Component({ })

export default class Timeline extends Vue {

    private tweets:any[] =  [];
    private unWatchRealtimeUpdate: Function = new Function();

    async mounted() {
        if (FirebaseConnectionStore.isConnected) {
            this.getTweets();
            return;
        }

        this.unWatchRealtimeUpdate = this.$watch(
            () => FirebaseConnectionStore.isConnected,
            () => this.getTweets()
        )
    }

    private async getTweets(){
        const result = await  ApiClient.serachTweetByHashtag("フヅクエ時間");
        this.tweets = result.statuses;
    }

    destroyed(): void {
        this.unWatchRealtimeUpdate();
    }

    private tweetText2Html(__tweet:any):string {
        return Utils.tweetText2Html(__tweet);
    }

    private getFormatedDate(date :string):string{
        return moment(date).format("M月D日 HH:mm");
    }

}
